import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";
import { BasicMaster } from "../models/basicmaster";


@Injectable({
  providedIn: 'root'
})
export class BasicMasterService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'basicmaster/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E/'; 
  
  constructor(private httpService: HttpWrapperService,private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint'); 
    this.apiEndpoint += this.apiUniqueId; 
  } 
   
  viewBasicMaster(generalpreferenceID?: number): Observable<Array<BasicMaster>> {
    return this.httpService.get(this.apiEndpoint + 'viewBasicMaster/'+ (generalpreferenceID ? generalpreferenceID : '')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveBasicMaster(generalpreferences: BasicMaster): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveBasicMaster/',generalpreferences).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  } 
  deleteBasicMaster(generalpreferenceID?: number): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteBasicMaster/'+ (generalpreferenceID ? generalpreferenceID : ''),generalpreferenceID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }      
    }));
  }
  getBasicMastersByName(BasicMaster_Name: string,filter: string, pagesize: number, pagenumber: number): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'getBasicMastersByName?BasicMasterName='+ (BasicMaster_Name ? BasicMaster_Name : '') + '&filter=' + ( '') + '&pagesize=' + (pagesize ? pagesize : 0) + '&pagenumber=' + (pagenumber ? pagenumber : 0)).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }      
    }));
  }  
}
